import { Component, Vue } from 'vue-property-decorator';
import { ApplicationConfiguration } from '@/types';
import appStore from '@/store/app';

@Component
export default class FooterBar extends Vue {

    private get isFooterBarVisible(): boolean {
        return appStore.isFooterBarVisible;
    }

    private get configuration(): ApplicationConfiguration {
        return appStore.applicationConfiguration;
    }
}